
import { Link } from "react-router-dom";
import crown from "../../Images/crown.jpg";
import crowns from "../../Images/crowns.jpg";
import crown1 from "../../Images/crown1.jpg";
import crown2 from "../../Images/crown2.jpg";
import crown3 from "../../Images/crown3.jpg";
import crown4 from "../../Images/crown4.jpg";
import crown5 from "../../Images/crown5.jpg";
import crown6 from "../../Images/crown6.jpg";
import { FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";




export default function Crowns() {
  return (
    <>
    <div
  className=" relative w-full min-h-[300px] sm:min-h-[400px] lg:min-h-[350px]
    bg-cover bg-[center_30%] flex items-center pt-28 sm:pt-32 "
  style={{ backgroundImage: `url(${crowns})` }}
>
  {/* Dark Overlay */}
  <div className="absolute inset-0 bg-black/55"></div>

  {/* Content */}
  <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <h1
      className=" text-white font-extrabold text-center text-3xl sm:text-2xl md:text-3xl lg:text-3xl xl:text-4xl
        leading-tight pt-5 pb-1 max-w-5xl -mt-12 sm:mt-0 mx-auto drop-shadow-[0_6px_20px_rgba(0,0,0,0.7)]" >
      Crowns - Before and After
    </h1>
  </div>
  </div>

<div className=" px-2 py-2 mt-12">
  <div className="max-w-7xl mx-auto px-6">
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center">

        {/* left Image */}
      <div>
        <img
          src={crown}
          alt="Dental Consultation"
          className="w-full h-[380px] object-cover rounded-2xl"
        />
      </div>

      {/* right Content */}
      <div>
        <h1 className="text-3xl font-semibold text-[#0a0a5c] mb-3">
          Are you considering tooth crowns to improve your smile?
        </h1>

        <p className="text-gray-700 ">
            Take a look at our before and after photos to see the amazing transformation that our patients have achieved with tooth crowns. As you can see, tooth crowns can make a big difference in the appearance of your smile.- depending on expectations Contact us today to schedule a consultation! We would be happy to discuss our dental crown options with you.
        </p>

      </div>
</div>
  </div>
</div>

<div className="max-w-7xl mx-auto px-4 py-10">
  <h2 className="text-center text-3xl font-semibold text-[#0a0a5c] mb-8">
    Porcelain Crowns - Before and After Pictures
  </h2>

  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
    {/* Item */}
    <div className="space-y-2">
      <div className="relative">
        <img
          src={crown1}
          alt="Before"
          className="w-full h-58 object-cover rounded-lg"
        />
        
      </div>
      <div className="relative">
        <img
          src={crown2}
          alt="After"
          className="w-full h-58 object-cover rounded-lg"
        />
        
      </div>
    </div>

    {/* Repeat same block */}
    <div className="space-y-2">
      <div className="relative">
        <img src={crown3} alt="Dental crown treatment" className="w-full h-58 object-cover rounded-lg" />
        
      </div>
      <div className="relative">
        <img src={crown4} alt="Crown restoration results" className="w-full h-58 object-cover rounded-lg" />
        
      </div>
    </div>

    <div className="space-y-2">
      <div className="relative">
        <img src={crown5} alt="Porcelain crown procedure" className="w-full h-58 object-cover rounded-lg" />
        
      </div>
      <div className="relative">
        <img src={crown6} alt="Dental crown finishing" className="w-full h-58 object-cover rounded-lg" />
        
      </div>
    </div>    
  </div>
</div>


<div className="max-w-7xl mx-auto px-6 py-14">
  <div className="grid grid-cols-1 md:grid-cols-2 gap-16">

    {/* LEFT COLUMN */}
    <div>
      <h1 className=" text-[#0a0a5c] font-semibold text-3xl mb-6">
        Things to Know Before You Get Dental Crowns
      </h1>

      <div className="space-y-6 text-sm text-gray-700 leading-relaxed">
        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
            1. Not all tooth decay requires the need for a tooth crown.
          </h4>
          <p>
            If the tooth decay is caught early, a filling may be all that is needed to restore the tooth
          </p>
        </div>

        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
            2. Getting a filling today does not rule out the need for a tooth crown in the future.
          </h4>
          <p>
            The tooth may develop new decay or the old filling may fail, requiring a tooth crown.
          </p>
        </div>

        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
            3. A tooth crown will not prevent new decay from forming.
          </h4>
          <p>
           It is important to continue to brush and floss your teeth and see your dentist regularly for cleanings and exams.
          </p>
        </div>

        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
            4. There are different types of dental crowns.
          </h4>
          <p>
            The type of dental crown you receive will be based on several factors, including the location of the tooth, the amount of tooth that is visible above the gum line, and your bite.
          </p>
        </div>

        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
            5. Dental crowns can be made from different materials.
          </h4>
          <p>
            The most common type of dental crown is made from porcelain-fused-to-metal. Other materials used for dental crowns include all-ceramic and all-metal.
          </p>
        </div>

        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
            6. Dental crowns are not just for adults.
          </h4>
          <p>
            Children may also need dental crowns to protect their teeth from decay.
          </p>
        </div>
        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
            7. Dental crowns are not just for your teeth.
          </h4>
          <p>
            They can also be used to support a dental bridge or to cover a dental implant. So if you are considering dental crowns, be sure to ask one of our experienced dentists about all of your options. And be sure to take care of your teeth so you can avoid the need for dental crowns in the future!
          </p>
        </div>
      </div>
    </div>

    {/* RIGHT COLUMN */}
    <div>
      <h1 className=" text-[#0a0a5c] font-semibold text-3xl mb-6">
        Things to Know After You Get Dental Crowns
      </h1>

      <div className="space-y-6 text-sm text-gray-700 leading-relaxed">
        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
            1. Dental crowns may require special care.

          </h4>
          <p>
            Be sure to brush and floss your teeth as directed by your dentist.

          </p>
        </div>

        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
           2. See your dentist for regular cleanings and exams.
          </h4>
          <p>
          It is important to see your dentist every 6 months for a cleaning and exam. This will help to ensure that your dental crowns are in good condition and that your teeth and gums are healthy.          </p>
        </div>

        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
            3. Dental crowns may make it difficult to floss between your teeth.

          </h4>
          <p>
            It is important to floss around the base of the dental crowns to avoid plaque and bacteria build-up. Your dentist can show you the proper way to floss around your dental crowns.

          </p>
        </div>

        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
            4. Avoid biting down on hard objects.

          </h4>
          <p>
            Dental crowns are made to withstand a lot of wear and tear, but they are not indestructible. Biting down on hard objects, such as ice or hard candy, can crack or break your dental crowns.
          </p>
        </div>

        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
            5. Be mindful of what you eat and drink.
          </h4>
          <p>
            Certain foods and drinks, such as coffee and red wine, can stain your dental crowns. To avoid staining, brush your teeth after eating or drinking.
          </p>
        </div>

        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
            6. Avoid eating sticky or chewy foods.

          </h4>
          <p>
          Sticky and chewy foods can pull your dental crowns off. If you must eat these types of foods, be sure to brush your teeth afterwards.          </p>
        </div>

        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
            7. Use a soft toothbrush to brush your teeth.
          </h4>
          <p>
           A soft toothbrush will help to avoid scratching or damaging your dental crowns.
          </p>
        </div>

        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
            8. Avoid using whitening toothpaste.

          </h4>
          <p>
        Whitening toothpaste can damage your dental crowns and make them more susceptible to staining.
          </p>
        </div>

        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
            9. Dental crowns will not change the colour of your teeth.

          </h4>
          <p>
        If you are concerned about the colour of your teeth, you may want to consider getting veneers instead.
          </p>
        </div>

        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
            10. Dental crowns may make your teeth feel sensitive.
          </h4>
          <p>
        This is normal and should go away after a few days. If the sensitivity persists, please contact your dentist.
          </p>
        </div>

        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
        11. Dental crowns are not permanent.
          </h4>
          <p>
            They will eventually need to be replaced. The average lifespan of a dental crown is 5 to 15 years. Our Dental Crown Testimonials if you are now interested in getting dental crowns, be sure to contact us by scheduling an appointment online. We will be happy to help you!

          </p>
        </div>
      </div>
    </div>

  </div>
</div>


<div className="w-full h-[180px] overflow-hidden mt-4">
  <iframe
    title="clinic-map"
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3445.0390050498395!2d71.9162331!3d30.292951199999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x393b557588a60575%3A0x79afa5462675bee1!2sSmile%20expert%20dental%20clinic!5e0!3m2!1sen!2s!4v1767274320473!5m2!1sen!2s"
    width="100%"
    height="450"
    style={{ border: "0" }}
    allowFullScreen
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
  />
</div>

<div className="bg-[#0c2340] text-white pt-[60px] pb-[60px] px-[40px] mt-0">
  <div className="flex justify-between flex-wrap max-w-[1400px] mx-auto gap-[40px]">
    {/* COLUMN 1 */}
    <div className="min-w-[200px]">
  <h3 className="text-[20px] mb-[20px]">Useful Links</h3>

  <Link to="/about/meet-our-team" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    About Us
  </Link>

  <Link to="/contact" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Contact Us
  </Link>

  <Link to="/about/meet-our-team" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Meet the Team
  </Link>

  <Link to="/teeth-whitening-before-and-after" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Before & After
  </Link>

  <Link to="/blog" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Blogs
  </Link>
</div>


    
    <div className="min-w-[200px]">
  <h3 className="text-[20px] mb-[20px]">Treatments</h3>

  <Link to="/treatment/exam" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Exam & X-Rays Check-Up
  </Link>

  <Link to="/emergency-dentist" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Dental Emergency
  </Link>

  <Link to="/t/implants" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Smile Makeover
  </Link>

  <Link to="/t/veneer" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Veneers
  </Link>

  <Link to="/t/implants" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Dental Implants
  </Link>

  <Link to="t/canals" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Root Canal Treatment
  </Link>

  <Link to="/t/orthodontist" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Orthodontic Braces
  </Link>

  
</div>


    <div className="min-w-[200px]">
  <h3 className="text-[20px] mb-[20px]">Dental Problems</h3>

  <Link to="/yellow-teeth-treatment" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Yellow Teeth
  </Link>

  <Link to="/teeth-cleaning" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Teeth Cleaning
  </Link>

  <Link to="/missing-teeth-treatment" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Missing Teeth
  </Link>

  <Link to="/broken-chipped-tooth" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Broken Chipped Tooth
  </Link>

  <Link to="/gum-disease" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Gum Disease
  </Link>

  <Link to="/crooked-teeth-treatment" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Crooked Teeth
  </Link>

  <Link to="/sore-teeth-treatment" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Sensitive & Sore Teeth
  </Link>

  <Link to="/dental-anxiety" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Dental Anxiety
  </Link>
</div>


    <div className="min-w-[200px]">
  <h3 className="text-[20px] mb-[20px]">Patient Safety</h3>

  <Link to="/7x-safety" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    7X SAFETY
  </Link>

  <Link to="/4-step-sterilization" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    4 Step Sterilization
  </Link>

  <Link to="/safety-equipment" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Safety Equipment
  </Link>

  <Link to="/equipment-technology" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Equipment & Technology
  </Link>

  <Link to="/quality" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Quality
  </Link>
</div>


    <div className="min-w-[250px]">
              <h3 className="text-[20px] mb-[20px]">Get in touch</h3>
        
              <p className="my-2 flex gap-[10px] ">📧 aneelabrar555@gmail.com</p>
        
              <p className="my-3 flex gap-[10px]  ">📞 03008395562</p>
        
              <p className="my-2 flex gap-[10px] px-2">
                  <span className="">📍 Saddique Hospital Stadium Road Khanewal</span>
              </p>
        
              <p className="mt-6 font-semibold "> 🕒 Clinic Timing <br/>   <span className="ml-7">11:00am to 9:00pm</span></p>
        
              <div className="text-left bg-[#0c2340] text-white py-[50px] px-[20px]">
                <div className="flex gap-[15px] mt-[20px]">
                  <a

                      href="https://www.facebook.com/share/17zJppb7qh/"

                      target="_blank"

                      rel="noopener noreferrer"

                      className="w-[35px] h-[35px] bg-blue-900 flex justify-center items-center rounded-[8px] no-underline"

                      aria-label="Follow us on Facebook"

                    >

                      <FaFacebookF size={20} color="white" />
                  </a>
        
                  <a

        
                      href="https://instagram.com"

        
                      target="_blank"

        
                      rel="noopener noreferrer"

        
                      className="w-[35px] h-[35px] bg-[#000000] flex justify-center items-center rounded-[8px] no-underline"

        
                      aria-label="Follow us on Instagram"

        
                    >

        
                      <FaInstagram size={20} color="white" />
                  </a>
        
                  <a

        
                      href="https://youtube.com"

        
                      target="_blank"

        
                      rel="noopener noreferrer"

        
                      className="w-[35px] h-[35px] bg-[#FF0000] flex justify-center items-center rounded-[8px] no-underline"

        
                      aria-label="Subscribe to our YouTube channel"

        
                    >

        
                      <FaYoutube size={22} color="white" />
                  </a>
                </div>
              </div>
            </div>
    
  </div>
   <div className="w-full text-center justify-end mb-0 border-t border-gray-300 pt-4">
  <p className="text-sm text-gray-400">
    © SmileExpert
    <span className="mx-2 text-gray-600">|</span>
    Powered by{" "}
    <a
      href="https://verdant-soft.com/"
      target="_blank"
      rel="noopener noreferrer"
      className="text-gray-300 hover:text-blue-400 no-underline font-medium transition-colors duration-300 "
    >
      Verdant Soft
    </a>
  </p>
</div>

</div>




</>
  )
}








